import React from "react";
import { setUsedEquipment } from "../../../../store/slices/applicationManagement/managementSlice";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import { useDispatch, useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useFormik } from "formik";
import dayjs from "dayjs";
import FormControl from "@mui/material/FormControl";
import CustomDatePicker from "../../../../components/shared/CustomDatePicker";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import { useGiveBackEquipmentMutation } from "../../../../store";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { GIVE_BACK_EQUIPMENT_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import * as yup from "yup";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const GiveBackModal = () => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const dispatch = useDispatch();
  const { giveBackEquipmentDialogOpen } = useSelector(
    (state) => state.dialogSlice
  );
  const { usedEquipment } = useSelector((state) => state.managementSlice);
  const [giveBackEquipment, { isLoading }] = useGiveBackEquipmentMutation();

  const handleClose = () => {
    dispatch(setUsedEquipment(null));
    dispatch(closeDialog(GIVE_BACK_EQUIPMENT_DIALOG));
  };

  const handleDateChange = ({ name, value }) => {
    formik.setFieldValue(name, value);
  };

  const formik = useFormik({
    initialValues: {
      id: usedEquipment.id,
      giveBackDate: usedEquipment.giveBackDate,
    },
    validationSchema: yup.object().shape({
      giveBackDate: yup.date().required("Bu alan zorunludur"),
    }),
    onSubmit: async (values, bag) => {
      try {
        const model = {
          id: values.id,
          giveBackDate: dayjs(values.giveBackDate).format("YYYY-MM-DD"),
        };

        giveBackEquipment(model).then((res) => {
          if (res) {
            if (!res.data.isSuccess) {
              dispatch(openErrorToast(res.data.message));
            } else {
              dispatch(openSuccessToast("İşlem Başarılı"));
              handleClose();
            }
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });
  return (
    <Modal
      open={giveBackEquipmentDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <CalendarMonthIcon sx={{ color: "primary.main", fontSize: 32 }} />
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontWeight: 700,
              color: "primary.main",
              letterSpacing: 0.5,
            }}
          >
            İade Alma Tarihi Gir
          </Typography>
        </Stack>
        <form onSubmit={formik.handleSubmit}>
          <FormControl
            fullWidth
            sx={{ m: 1 }}
            error={
              formik.touched.giveBackDate && Boolean(formik.errors.giveBackDate)
            }
          >
            <CustomDatePicker
              handleChange={handleDateChange}
              value={formik.values.giveBackDate}
              id="giveBackDate"
              label="İade Alma Tarihi"
            />
            {formik.touched.giveBackDate && (
              <FormHelperText>{formik.errors.giveBackDate}</FormHelperText>
            )}
          </FormControl>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700, mt: 2 }}
          >
            Kaydet
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default GiveBackModal;
